import { render, staticRenderFns } from "./InspectionViewInspectionEditInspection.vue?vue&type=template&id=fb2b2db2&scoped=true"
import script from "./InspectionViewInspectionEditInspection.vue?vue&type=script&lang=js"
export * from "./InspectionViewInspectionEditInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2b2db2",
  null
  
)

export default component.exports